import React, { useEffect } from "react";
import { FaChartLine, FaCog, FaUser, FaUserEdit } from "react-icons/fa";
import { HiUserAdd } from "react-icons/hi";
import { SiPrivateinternetaccess } from "react-icons/si";
import { Link } from "react-router-dom";
import InsertStation from "./InsertStation";
import { FaTrainSubway } from "react-icons/fa6";
const listItems = [
  {
    label: "Add User",
    icon: "FaUser",
    link: "Control",
    bgcolor: "#29b5f6ff",
  },
  {
    label: "Add Access Rights",
    icon: "AddAccessRight",
    link: "Control",
    bgcolor: "#f44336ff",
  },
  {
    label: "Reports",
    icon: "FaChartLine",
    link: "Control",
    bgcolor: "#ffeb3bff",
  },

  {
    label: "Add Station",
    icon: "FaTrainSubway",
    link: "Control",
    bgcolor: "#5ffcf7ff",
  },
];
const iconMap = {
  FaUser: <HiUserAdd />,

  // FaCog: <SiPrivateinternetaccess />,
  AddAccessRight: <SiPrivateinternetaccess />,
  FaChartLine: <FaChartLine />,
  FaTrainSubway: <FaTrainSubway />,
};
const AdminHome = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  return (
    <div
      style={{ background: "#253343ff", minHeight: "100vh", color: "white" }}
    >
      <div className="container text-center" style={{}}>
        <h5 className="pt-3"> Admin panel</h5>
        <hr />
        <div className="row">
          {listItems.map((item, i) => (
            <div className="col-md-4 " key={i}>
              <Link
                to="Control"
                style={{ textDecoration: "none" }}
                state={{ from: item.label }}
              >
                <div
                  className="papaDiv mt-2  badhaHoja d-flex align-items-center gap-2 m-0 p-0 position-relative text-black"
                  style={{
                    background: item.bgcolor,
                    height: "200px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      background:
                        "linear-gradient(to right, #fffefe3c, #58585872)",
                      height: "200px",
                      width: "100%",
                      zIndex: 2,
                    }}
                  >
                    <h5>{item.label}</h5>
                  </div>
                  <div
                    className="position-absolute top-50 end-0 translate-middle-y"
                    style={{
                      fontSize: "200px",
                      zIndex: 1,
                      color: "rgba(0, 0, 0, 0.32)",
                    }}
                  >
                    {iconMap[item.icon]}
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default AdminHome;
